export default __webpack_public_path__ + "static/media/IMG-20241210-WA0031.b6bbf2ec.jpg";